import * as Yup from "yup"

export const CreateDevisSchema = Yup.object().shape({
    clientIri: Yup.string().required("Ce champ est requis"),
    region: Yup.string().required("Ce champ est requis"),
    categoryType: Yup.string().required("Ce champ est requis")
})